import React from "react";

const Footer = () => {
    return (
        <>
            {/* Footer */}
            <footer className="py-6 bg-blue-900 text-center text-white">
                <p>&copy; 2025 Hodgies Art. All rights reserved.</p>
                <p className="text-gray-400">Website by Integrating Technology</p>
            </footer >
        </>
    );
};

export default Footer;